<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-loan__export-order-list">
        <!-- 查询条件 -->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item label="文件名">
            <el-input v-model="dataForm.fileName" placeholder="文件名" clearable />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="dataForm.status" placeholder="请选择状态" clearable>
              <el-option label="全部" value="" />
              <el-option label="生成中" value="PROCESSING" />
              <el-option label="已生成" value="SUCCESS" />
              <el-option label="生成失败" value="FAIL" />
              <el-option label="空数据" value="EMPTY" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="date"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="导出开始日期"
                      end-placeholder="导出结束日期"
                       :default-time="['00:00:00','23:59:59']"
                       value-format="yyyy-MM-dd HH:mm:ss"
                      @change="getTimes"
                      unlink-panels>
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t("query") }}</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
          <el-table-column prop="fileName" label="文件名" align="center" />
          <el-table-column prop="name" label="操作人" align="center" />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="statusTagType(scope.row.status)"
                size="small"
              >
                {{ statusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="exportTime" label="导出时间" align="center" />
          <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              :disabled="!scope.row.fileUrl"
              @click="downloadFile(scope.row)"
            >
          下载
        </el-button>
    </template>
  </el-table-column>
  </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>
  <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
    </el-card>
  </template>
  <script>
    import mixinViewModule from '@/mixins/view-module'
    import { set } from 'lodash';
    export default {
      mixins: [mixinViewModule],
      data () {
        return {
          mixinViewModuleOptions: {
            getDataListURL: "/loan/export/order/list",
            getDataListIsPage: true
          },
          date:null, 
          dataForm: {
            fileName: "",
            status: "",
            startDate: "",
            endDate: ""
          },
        }
      },
      created() {
         this.getDataList()
      },
      watch: {
          $route: {
            handler(newRoute) {
              if (newRoute.path === '/loan-orderexportfile') {
                this.getDataList();
              }
            },
            immediate: true,
            deep: true
        }
      },
      methods: { 
        //导出时间戳设置    
        getTimes() {
          if (this.date != null) {
            this.dataForm.startDate = this.date[0]
            this.dataForm.endDate = this.date[1]
          } else{
            delete this.dataForm.startDate
            delete this.dataForm.endDate
          }
       },
       // 状态转中文
        statusText(status) {
          const map = {
            PROCESSING:'生成中',
            SUCCESS: '生成成功',
            FAIL: '生成失败',
            EMPTY: '空数据'
          }
          return map[status] || status
        },
        
        // 状态对应tag颜色类型
        statusTagType(status) {
          return {
            SUCCESS: 'success',
            FAIL: 'danger',
            EMPTY: 'warning'
          }[status] || 'info'
        },
         downloadFile(item) {
          if (!item.fileUrl) {
            this.$message.warning('文件不可用!')
            return
          }
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = item.fileUrl
          link.target = '_blank'
          link.download = item.fileName
          
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }
  </script>
  <style scoped lang="scss">
      .pay_type{
        display: flex;
        margin-bottom: 20px;
        div{
          width: 100px;
          height: 42px;
          text-align: center;
          line-height: 42px;
          margin-right: 20px;
          border-radius: 6px 6px 0 0;
  
        }
      }
      .back1{
        background-color: rgb(23,179,163); 
        color: #fff;
        cursor: pointer; 
      }
      .back2{
        background-color: #f2f2f2;
        cursor: pointer;
      }
      // 状态标签样式增强
    .el-tag {
      font-weight: 500;
      &.el-tag--success {
        background-color: #f6ffed;
        border-color: #b7eb8f;
        color: #52c41a;
      }
      &.el-tag--danger {
        background-color: #fff1f0;
        border-color: #ffa39e;
        color: #ff4d4f;
      }
      &.el-tag--warning {
        background-color: #fffbe6;
        border-color: #ffe58f;
        color: #faad14;
      }
    }
  
    // 下载按钮禁用状态
    .el-button.is-disabled.el-button--primary.is-plain {
      color: #c0c4cc;
      background-color: #f5f7fa;
      border-color: #e4e7ed;
    }
  </style>  